import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Btn, Card, Field, Input } from "@/components/Ui";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data.status);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-5 py-16" data-testid="forgot-password-page">
      <h1 className="font-display text-3xl font-black tracking-tight text-[#102A43]">
        Reset your password
      </h1>
      <p className="mt-2 text-sm text-[#667788]">
        Enter the email registered on your ADIT Connect account and we will send a reset link valid
        for 60 minutes.
      </p>
      <Card className="mt-7">
        {sent ? (
          <div className="text-center" data-testid="forgot-password-sent">
            <MailCheck className="mx-auto h-10 w-10 text-[#13795B]" />
            <p className="mt-4 text-sm text-[#334e68]">{sent}</p>
            <Link to="/login" className="mt-5 inline-block">
              <Btn variant="ghost" data-testid="forgot-back-to-login">Back to sign in</Btn>
            </Link>
          </div>
        ) : (
          <form onSubmit={submit}>
            <Field label="Email">
              <Input data-testid="forgot-email-input" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} />
            </Field>
            {error && (
              <p data-testid="forgot-error" className="mt-4 rounded-[9px] bg-[#fdecec] px-3 py-2 text-sm text-[#B42318]">
                {error}
              </p>
            )}
            <Btn data-testid="forgot-submit-btn" loading={busy} className="mt-6 w-full">
              Send reset link
            </Btn>
            <p className="mt-5 text-center text-sm text-[#667788]">
              <Link to="/login" className="font-semibold text-[#147D78] underline">Back to sign in</Link>
            </p>
          </form>
        )}
      </Card>
    </div>
  );
}
